import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import moment from 'moment';
import { ThemeProvider } from 'styled-components';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import Routes from './routes';
import Theme from './config/themes';
import store from './store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import '../assets/images/favicon.ico';
import { config } from '../authConfig';

const pca = new PublicClientApplication(config);

moment.locale('es');

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <MsalProvider instance={pca}>
    <ThemeProvider theme={Theme}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </ThemeProvider>
  </MsalProvider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// check if HMR (Hot Module Replacement) is enabled
if (module.hot) {
  module.hot.accept();
}
